<template>
  <div class="study-all-box">
    <Header />
    <div class="study-middle-box" ref="middleBox">
      <!-- 顶部轮播banner -->
      <!-- <div class="study-banner-box" v-if="bannerData&&bannerData.length>0">
        <el-carousel :loop="true" :trigger="'click'" :interval="10000">
          <el-carousel-item v-for="item,index in bannerData" :key="index" :style="`background-image:url(${item.url})`">
          </el-carousel-item>
        </el-carousel>
      </div> -->

      <!-- 顶部轮播banner -->

      <div class="study-banner-box" v-if="bannerData&&bannerData.length>0">
        <swiper :options="swiperOption">
          <swiper-slide v-for="item,index in bannerData" :key="index" :style="`background-image:url(${item.url})`"></swiper-slide>

          <div class="swiper-pagination" slot="pagination"></div>

        </swiper>

      </div>

      <!-- 写在研学前 -->
      <div class="study-xzyxq-box">
        <div class="study-xzyxq-inner">
          <div class="public-title">
            <div class="title-inner xzyxq"></div>
          </div>

          <div class="img-box"></div>

        </div>
      </div>

      <!-- 学知领航 -->
      <div class="study-xzlh-box" v-if="xzlhList&&xzlhList.length>0">
        <div class="study-xzlh-inner">
          <div class="public-title">
            <div class="title-inner xzlh"></div>
          </div>
          <div class="message-box">
            <p>为能够达到“深度研学”，做好知识铺垫，构建内容框架，请在研学行程开始前，<br>
              完成下方与自身研学主题相关的专题知识课程和课题研究指导课程的学习</p>
          </div>
          <div class="xzlh-list">
            <div class="item" v-for="item,index in xzlhList" @click="jumpCourse(item)" :key="index">
              <div class="thumb-image" :style="`background-image: url(${item.photo});`"></div>
              <div class="title">
                <p>{{ item.name }}</p>
              </div>
            </div>
            <div class="sub-visibility"></div>
            <div class="sub-visibility"></div>

          </div>
        </div>
      </div>
      <!-- 名家名课 -->
      <div class="study-mjmk-box" v-if="mjmkList&&mjmkList.length>0">
        <div class="study-mjmk-inner">
          <div class="public-title">
            <div class="title-inner mjmk"></div>
          </div>
          <div class="mjmk-list">
            <div class="item" v-for="item,index in mjmkList" @click="jumpCourse(item)" :key="index">
              <div class="thumb-image">
                <div class="img-box" :style="`background-image: url(${item.photo});`">
                </div>
              </div>
              <div class="title">
                {{ item.name }}
              </div>
            </div>

            <div class="sub-visibility"></div>
            <div class="sub-visibility"></div>
          </div>
        </div>
      </div>
      <!-- 书海纵横 -->
      <div class="study-shzh-box">
        <div class="study-shzh-inner">
          <div class="public-title">
            <div class="title-inner shzh"></div>
          </div>
          <div class="message-box">
            <p>为能够达到 “充分研学”，展开多维视角进行思考，<br>
              可在下方推荐书目中选择与研学主题和任务相关的书目进行行前阅读</p>
          </div>
          <div class="shzh-list">
            <img src="../../assets/study/books.png">
          </div>
        </div>
      </div>
      <!-- 全能助手 -->
      <div class="study-qnzs-box">
        <div class="study-qnzs-inner">
          <div class="public-title">
            <div class="title-inner qnzs"></div>
          </div>
          <div class="message-box">
            <p>
              研学旅途中伴随着多种多样的学习活动与任务，可能是视频创作，亦或是课题研究，需要你大展身手<br>
              请根据研学手册的具体要求，在行程开始前做好所需工具的下载准备<br>
              另外，图片展示网站与官方记录片网站所展示的案例，相信会对你的自由创作产生启发！<br>
            </p>
          </div>
          <div class="qnzs-list">
            <template v-if="qnzsList&&qnzsList.length>0">
              <div class="top-list">
                <div class="item" v-for="item,index in qnzsList" :key="index">
                  <div :class="['inner',item.last?'noBorder':'']">
                    <div class="file-type excel"></div>
                    <div class="name" @click="previewFile(item)">
                      <p>{{`${item.name}.${(item.path&&item.path.match(/\.([^.]+)$/)[1])||'.docx'}`}}</p>
                    </div>
                    <div class="download" @click="downloadFile(item)"></div>
                  </div>
                </div>
              </div>
            </template>
            <div class="split-line" v-if="qnzsList&&qnzsList.length>0&&footerLogo&&footerLogo.length>0"></div>

            <div class="bottom-list" v-if="footerLogo&&footerLogo.length>0">
              <a :href="item.url" v-for="item,index in footerLogo" :key="index" target="_blank" class="item" :class="[item.fontSize?'fz17':'']" v-html="item.name">
              </a>
            </div>
          </div>
        </div>
      </div>

    </div>
    <StudyFooter />

    <!-- 文件预览弹框 -->
    <component :is="dialogPdfConfig.name" :dialogConfig="dialogPdfConfig"></component>
  </div>

</template>

<script>
import Header from '@/components/Header.vue';
import StudyFooter from "@/components/StudyFooter";
import services from "@/config/services.js";
import axios from 'axios';
import staticData from './staticData';
import VueBaseDialog from "@/components/VueBaseDialog";
import PreviewPdf from '@/components/PreviewPdf';
export default {
  name: 'study',
  components: { Header, StudyFooter, VueBaseDialog, PreviewPdf },
  data () {
    return {
      xzlhList: [],// 学知领航列表
      mjmkList: [],//名家名课列表
      qnzsList: [], // 全能助手列表
      school_code: "",// 学校code
      bannerData: staticData.bannerData,
      footerLogo: staticData.footerLogo,
      dialogPdfConfig: {
        name: '',
        title: '文件预览',
        path: '',
      },
      specialCode: "100035",// 学校code 测试线用100064 | 正式线 100035
      studyTripId: "92", // 学知领航分类id,测试线用35,正式待定
      famousClassesId: "93",// 名家名课分类id,测试用36,正式待定
      multiAideId: "94", // 全能助手分类id,测试用37,正式待定

      swiperOption: {
        loop: true,
        autoplay: {
          delay: 3000,
          // stopOnLastSlide: false,
          disableOnInteraction: false
        },
        // 显示分页
        pagination: {
          el: ".swiper-pagination",
          clickable: true //允许分页点击跳转
        },
        flag: ""
      }
    };
  },
  mounted () {
    this.$openLoading()
    this.judgeSchool()
    this.requestListData()
  },
  methods: {
    // 请求列表数据
    requestListData () {
      services.getStudyTrip({ category_id: this.studyTripId, school_code: this.school_code }).then(res => {
        if (res.data && res.data.length > 0) {
          this.xzlhList = res.data
        }
      })

      services.getFamousClasses({ category_id: this.famousClassesId, school_code: this.school_code }).then(res => {
        if (res.data && res.data.length > 0) {
          this.mjmkList = res.data
        }
      })

      services.multiAide({ category_id: this.multiAideId, school_code: this.school_code }).then(res => {
        if (res.data && res.data.length > 0) {
          this.qnzsList = res.data
          if (res.data.length % 2 == 0) {
            this.$set(this.qnzsList[this.qnzsList.length - 1], "last", true)
            this.$set(this.qnzsList[this.qnzsList.length - 2], "last", true)
          } else {
            this.$set(this.qnzsList[this.qnzsList.length - 1], "last", true)
          }
        }
      })
      this.$closeLoading()
    },
    // 判断学校code
    judgeSchool () {
      // 本地开发环境
      if (process.env.NODE_ENV == 'development') {
        this.specialCode = '100064'
        this.studyTripId = "35"
        this.famousClassesId = "36"
        this.multiAideId = "37"
      } else {
        if (process.env.VUE_APP_FLAG === 'pro') {
          // 正式环境 
          this.specialCode = '100035'
          this.studyTripId = "92"
          this.famousClassesId = "93"
          this.multiAideId = "94"
        } else {
          // 测试环境 
          this.specialCode = '100064'
          this.studyTripId = "35"
          this.famousClassesId = "36"
          this.multiAideId = "37"
        }
      }

      if (this.$route.params && this.$route.params.schoolcode) {
        this.school_code = this.$route.params.schoolcode
        if (this.school_code != this.specialCode) {
          window.open(`/${this.school_code}/user/myClass`, "_self")
        }
      }
    },
    // 跳转到院校端课程详情
    jumpCourse (item) {
      window.open(`/center/${this.school_code}/class/${item.id}`)
    },
    // 下载文件
    downloadFile (row) {
      let that = this
      that.$openLoading()
      axios({
        url: services.XUEXI_SERVER + `/api/yanxue/material/download`,
        params: { id: row.id, name: row.name, is_download: 1, },
        method: 'get',
        responseType: 'arraybuffer',
      }).then(res => {
        that.$closeLoading()
        if (res.status == 200 && res.data) {
          let newUrl = window.URL.createObjectURL(new Blob([res.data]));
          let type = (row.path && row.path.match(/\.([^.]+)$/)[1]) || '.docx'
          that.createUrlBlob(newUrl, row.name, type)
        } else {
          this.$message.error("文件下载失败")
        }
      }).catch(() => {
        that.$openLoading()
      })
    },
    // 文件流处理
    createUrlBlob (url, fileName, type) {
      const a = document.createElement('a')
      a.style.display = 'none'
      a.href = url
      a.setAttribute('download', `${fileName}.${type}`);
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      window.URL.revokeObjectURL(url)
    },
    // 预览文件
    previewFile (item) {
      let that = this
      that.$openLoading()

      axios({
        url: services.XUEXI_SERVER + `/api/yanxue/material/download`,
        params: { id: item.id, is_download: 2, path: item.path },
        method: 'get',
        responseType: 'arraybuffer',
      }).then((res) => {
        that.$closeLoading()
        if (res.status == 200 && res.data) {
          const binaryData = [];
          binaryData.push(res.data);
          let newUrl = window.URL.createObjectURL(
            new Blob(binaryData, { type: "application/pdf" })
          );
          that.dialogPdfConfig.name = 'PreviewPdf'
          that.dialogPdfConfig.title = `${item.name}.${(item.path && item.path.match(/\.([^.]+)$/)[1]) || '.docx'}`
          that.dialogPdfConfig.path = newUrl
        } else {
          that.$errorMsg("文件预览失败")
        }
      }).catch(() => {
        that.$closeLoading()
      })
    },

  },
}

</script>

<style lang="less" scoped>
* {
  box-sizing: border-box;
}
.study-all-box {
  .study-middle-box {
    .public-title {
      display: flex;
      align-items: center;
      .title-inner {
        margin: 0 auto;
        width: 284px;
        height: 42px;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        &.xzlh {
          background-image: url('../../assets/study/title-xzlh.png');
        }
        &.mjmk {
          background-image: url('../../assets/study/title-mjmk.png');
        }
        &.shzh {
          background-image: url('../../assets/study/title-shzh.png');
        }
        &.qnzs {
          background-image: url('../../assets/study/title-qnzs.png');
        }
        &.xzyxq {
          width: 335px;
          height: 44px;
          background-image: url('../../assets/study/title-xzyxq.png');
        }
      }

      &::before,
      &::after {
        content: '';
        display: inline-block;
        flex: 1;
        height: 1px;
        background: #d1d4ea;
      }
    }
    .study-banner-box {
      width: 100%;
      height: 260px;
      ::v-deep .swiper-container {
        height: 100%;
        .swiper-pagination {
          position: absolute;
          left: 50%;
          bottom: 15px;
          transform: translateX(-50%);
          z-index: 10;
          .swiper-pagination-bullet {
            width: 8px;
            height: 8px;
            background: #ffffff;
            border-radius: 50%;
            display: inline-block;
            border: 1px solid #ffffff;
            cursor: pointer;
            &:not(:last-child) {
              margin-right: 8px;
            }
            &.swiper-pagination-bullet-active {
              background: #3478f6;
              border: 1px solid #ffffff;
            }
          }
        }
        .swiper-wrapper {
          height: 100%;
          .swiper-slide {
            height: 100%;
            background-size: cover;
            background-repeat: no-repeat;
            background-position: center;
          }
        }
      }
    }
    .study-xzlh-box {
      background-image: url('../../assets/study/bg-xzlh.png');
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      padding: 27px 0 14px;
      .study-xzlh-inner {
        width: 1200px;
        margin: 0 auto;
        .xzlh-list {
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
          // margin-top: 27px;
          .item {
            width: 280px;
            height: 158px;
            overflow: hidden;
            position: relative;
            cursor: pointer;
            margin-bottom: 22px;
            &:hover {
              .thumb-image {
                transform: scale(1.1);
              }
              .title {
                background: rgba(59, 128, 213, 1);
              }
            }
            .thumb-image {
              width: 100%;
              height: 100%;
              background-size: cover;
              background-position: center;
              transition: all 0.8s;
              background-repeat: no-repeat;
            }
            .title {
              position: absolute;
              left: 0;
              bottom: 0;
              width: 100%;
              height: 60px;
              background: rgba(59, 128, 213, 0.7);
              padding: 10px 14px 0;
              p {
                font-size: 16px;
                font-weight: bold;
                color: #ffffff;
                line-height: 20px;
                text-align: left;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                word-break: break-all;
              }
            }
          }
          .sub-visibility {
            flex: 0 0 280px;
            display: inline-block;
            overflow: visible;
          }
        }
      }
    }
    .study-mjmk-box {
      padding: 39px 0 12px;
      background-image: url('../../assets/study/bg-mjmk.png');
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;

      .study-mjmk-inner {
        width: 1200px;
        margin: 0 auto;
        position: relative;
        &::before,
        &::after {
          content: '';
          display: inline-block;
          width: 458px;
          height: 542px;
          background-size: cover;
          background-repeat: no-repeat;
          background-repeat: no-repeat;
        }
        &::before {
          background-image: url('../../assets/study/badge-left.png');
          position: absolute;
          left: 0;
          top: 20px;
          z-index: 1;
        }
        &::after {
          background-image: url('../../assets/study/badge-right.png');
          position: absolute;
          right: 0;
          top: 20px;
          z-index: 1;
        }
        .mjmk-list {
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
          margin-top: 40px;
          position: relative;
          z-index: 2;
          .item {
            width: 340px;
            height: 228px;
            margin-bottom: 48px;
            overflow: hidden;
            cursor: pointer;
            &:hover {
              .img-box {
                transform: scale(1.1);
              }
              .title {
                color: #3478f6;
              }
            }
            .thumb-image {
              width: 100%;
              height: 191px;
              overflow: hidden;
              .img-box {
                transition: all 0.8s;
                background-size: cover;
                background-position: center;
                background-repeat: no-repeat;
                width: 100%;
                height: 100%;
              }
            }

            .title {
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              padding: 20px 15px 0;
              font-size: 17px;
              line-height: 1;
              font-weight: bold;
              color: #424343;
              position: relative;
              text-align: left;
              &::before {
                content: '';
                display: inline-block;
                width: 5px;
                height: 18px;
                background: #c3ccd2;
                position: absolute;
                left: 0;
                bottom: 0;
              }
            }
          }
          .sub-visibility {
            flex: 0 0 340px;
            visibility: hidden;
            display: inline-block;
          }
        }
      }
    }
    .study-shzh-box {
      background: #f4f8fa;
      .study-shzh-inner {
        width: 1200px;
        margin: 0 auto;
        padding: 30px 0 40px;
        .shzh-list {
          // margin-top: 28px;
          img {
            width: 100%;
            height: auto;
          }
        }
      }
    }
    .study-qnzs-box {
      padding: 36px 0 32px;
      background-image: url('../../assets/study/bg-qnzs.png');
      width: 100%;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
      .study-qnzs-inner {
        width: 1200px;
        margin: 0 auto;
        .qnzs-list {
          // margin-top: 32px;
          background: rgba(255, 255, 255, 0.7);
          padding: 5px 0 0;
          .top-list {
            display: flex;
            align-items: center;
            justify-content: space-between;
            flex-wrap: wrap;
            padding-bottom: 32px;
            .item {
              width: 48%;
              flex-shrink: 0;
              position: relative;
              padding: 0 25px;
              &:hover {
                & {
                  background: rgba(241, 246, 254, 0.74);
                }
                .name {
                  p {
                    color: #3478f6;
                  }
                }
                .download {
                  background-image: url('../../assets/study/down-hover.png');
                }
              }
              .inner {
                height: 48px;
                width: 100%;
                display: flex;
                align-items: center;
                border-bottom: 1px dashed #ebebeb;
                .file-type {
                  &.excel {
                    width: 18px;
                    height: 18px;
                    background-image: url('../../assets/study/file-excel.png');
                  }
                  background-size: cover;
                  background-repeat: no-repeat;
                  background-position: center;
                  flex-shrink: 0;
                  margin-right: 10px;
                }
              }

              .name {
                width: 100%;
                overflow: hidden;
                p {
                  display: block;
                  height: 100%;
                  width: 95%;
                  line-height: 48px;
                  cursor: pointer;
                  text-align: left;
                  font-size: 16px;
                  color: #262626;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                }
              }
              .download {
                cursor: pointer;
                width: 20px;
                height: 18px;
                background-size: cover;
                background-image: url('../../assets/study/down.png');
                background-repeat: no-repeat;
                background-position: center;
                flex-shrink: 0;
              }
            }
          }
          .split-line {
            width: 96%;
            margin: 0 auto;
            border-bottom: 2px dashed #d7eaf8;
            margin-bottom: 20px;
            position: relative;
            &::before {
              content: '';
              display: inline-block;
              width: 10px;
              height: 20px;
              border-radius: 0 50px 50px 0;
              position: absolute;
              left: -24px;
              background-color: #eaf6ff;
              top: 50%;
              transform: translateY(-50%);
            }
          }
          .bottom-list {
            display: flex;
            align-items: center;
            justify-content: center;
            flex-wrap: wrap;
            .item {
              width: 12.5%;
              height: 67px;
              background: #ffffff;
              flex-shrink: 0;
              border: 1px solid #f6f6f6;
              position: relative;
              display: flex;
              flex-wrap: wrap;
              justify-content: center;
              align-items: center;
              font-size: 18px;
              font-weight: bold;
              color: #b9c0dd;
              padding: 12px 0;
              &.fz17 {
                font-size: 17px;
              }
              &:hover {
                background: #3478f6;
                color: #ffffff;
              }
              ::v-deep p {
                line-height: 1;
              }
            }
          }
        }
      }
    }
    .study-xzyxq-box {
      background: #fff;
      .study-xzyxq-inner {
        width: 1200px;
        margin: 0 auto;
        padding: 25px 0 30px;
        .public-title {
          margin-bottom: 18px;
        }
        .img-box {
          width: 100%;
          height: 340px;
          background-size: cover;
          background-repeat: no-repeat;
          background-position: center;
          background-image: url('../../assets/study/banner-xzyxq.png');
        }
      }
    }
  }
}
.eolDialog-outer-box {
  padding: 20px 30px;
  width: 100%;
  box-sizing: border-box;
}
::v-deep .vue-base-dialog-header {
  height: 40px;
  line-height: 44px;
  border-radius: 4px;
  background: #e5ecfb;
  .close {
    margin-top: 15px;
  }
}
.noBorder {
  border: none !important;
}
.message-box p {
  text-align: center;
  font-size: 15px;
  color: #898fa6;
  line-height: 20px;
  text-align: center;
}
.message-box {
  line-height: 1;
  padding: 15px 0 20px;
}
</style>